(function (window, document) {
  $("div.tag-nav-control.left").on("click", function () {
    const slider = $("#tag-list-slider")[0];
    if (slider) {
      slider.scrollLeft = slider.scrollLeft - 150;
    }
  });

  $("div.tag-nav-control.right").on("click", function () {
    const slider = $("#tag-list-slider")[0];
    if (slider) {
      slider.scrollLeft = slider.scrollLeft + 150;
    }
  });
})(window, document);
